import { useState, useEffect } from "react";
import { Menu, X, ArrowDown } from "lucide-react";
import { CV } from "@/data/cv";

const NAV = [
  { id: "ueber-mich", label: "Über mich" },
  { id: "werdegang", label: "Werdegang" },
  { id: "projekte", label: "Projekte" },
  { id: "bildung", label: "Bildung" },
  { id: "expertise", label: "Expertise" },
  { id: "kontakt", label: "Kontakt" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#F4F4F0]/85 backdrop-blur-md border-b-2 border-black"
          : "bg-transparent border-b-2 border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => handleNav("hero")}
          className="font-display text-base md:text-lg uppercase tracking-tight hover:text-[#FF3B00] transition-colors"
        >
          SDA<span className="text-[#FF3B00]">.</span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => handleNav(n.id)}
              className="font-mono-acc text-xs hover:text-[#FF3B00] transition-colors link-underline"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="nav-download-cv-btn"
            href={CV.cvFile}
            download
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 bg-black text-[#F4F4F0] font-mono-acc text-[11px] border-2 border-black hover:bg-[#FF3B00] hover:border-[#FF3B00] transition-colors"
          >
            <ArrowDown className="w-3.5 h-3.5" /> CV
          </a>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden p-2 border-2 border-black bg-[#F4F4F0]"
            aria-label="Menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#F4F4F0] border-t-2 border-black">
          <div className="px-5 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => handleNav(n.id)}
                className="font-display text-3xl uppercase text-left hover:text-[#FF3B00] transition-colors"
              >
                {n.label}
              </button>
            ))}
            <a
              data-testid="mobile-nav-download-cv-btn"
              href={CV.cvFile}
              download
              className="mt-2 inline-flex items-center gap-2 px-4 py-3 bg-black text-[#F4F4F0] font-mono-acc text-xs border-2 border-black w-fit"
            >
              <ArrowDown className="w-4 h-4" /> CV herunterladen
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
